/* eslint-disable ember/no-computed-properties-in-native-classes */
import EmberObject, { computed } from '@ember/object';
import {
  generateModerateGranularityFreqArray,
  generateFineGranularityFreqArray,
  generateExtremelyFineGranularityFreqArray,
} from '../utils/friendlyFrequencies';

const REDUCE_GRANULARITY_FOR_TEST_DATA_COLLECTION = false;

export default class Frequency extends EmberObject {
  startFrequency;
  stopFrequency;
  pointsPerDecade;
  decade;

  @computed('startFrequency', 'stopFrequency', 'pointsPerDecade') get narrowFrequencyArray() {
    var startFrequency = this.startFrequency;
    var stopFrequency = this.stopFrequency;
    var pointsPerDecade = this.pointsPerDecade;
    var result = this._createArray(startFrequency, stopFrequency, pointsPerDecade);
    if (REDUCE_GRANULARITY_FOR_TEST_DATA_COLLECTION) {
      result = [1000, 2000, 5000, 10000, 20000, 50000, 100000, 200000, 500000, 1000000];
      //result = [100000, 200000, 500000, 1000000, 2000000, 5000000, 10000000, 20000000, 50000000, 100000000];
    }
    return result;
  }

  @computed('decade', 'startFrequency', 'stopFrequency') get friendlyFrequencyArray() {
    const start = this.startFrequency;
    const end = this.stopFrequency;
    const decade = this.decade;

    if (REDUCE_GRANULARITY_FOR_TEST_DATA_COLLECTION) {
      return [1000, 2000, 5000, 10000, 20000, 50000, 100000, 200000, 500000, 1000000];
      //result = [100000, 200000, 500000, 1000000, 2000000, 5000000, 10000000, 20000000, 50000000, 100000000];
    }

    if (decade <= 0.5) {
      return generateExtremelyFineGranularityFreqArray(start, end);
    } else if (decade <= 5) {
      return generateFineGranularityFreqArray(start, end);
    } else {
      return generateModerateGranularityFreqArray(start, end);
    }
  }

  _createArray(startFreq, stopFreq, pointsPerDecade) {
    var multiplier = Math.pow(10, 1 / pointsPerDecade);
    var i = 0;
    var result = [];
    result.push(startFreq);
    do {
      result[i + 1] = result[i] * multiplier;
      i++;
    } while (result[i] < stopFreq);

    return result;
  }
}
